import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
const alignClasses = {
    right: "justify-end text-right",
    center: "m-auto table justify-center",
    left: "",
};
const TableHead = ({ className, styles, alignHeader, ...props }) => {
    const alignClass = alignClasses[alignHeader || "left"];
    return (_jsx("th", { style: {
            width: "auto",
            ...styles,
        }, className: cn("group align-middle", className), ...props, children: _jsx("div", { className: cn("flex h-12 w-full items-center justify-between text-gray-11", alignClass), children: _jsx("div", { children: props.children }) }) }));
};
TableHead.displayName = "TableHead";
export default TableHead;
